import {
  EVT_ENDED,
  EVT_PAUSE,
  EVT_PLAY,
  EVT_RATE_CHANGE,
  EVT_READY,
  EVT_SESSION_END,
  EVT_SESSION_START,
  EVT_VIEW,
} from 'constants/videoAnalyticsEvents';

import * as segmentsListeners from './video-session/segmentsListener';
import { VideoSession } from './video-session/videoSession';

const videoSession = new VideoSession();

segmentsListeners.init();
videoSession.on([EVT_READY], segmentsListeners.videoLoaded);
videoSession.on([EVT_VIEW], segmentsListeners.videoView);
videoSession.on([EVT_SESSION_START], segmentsListeners.sessionStart);
videoSession.on([EVT_SESSION_END], segmentsListeners.sessionEnd);
videoSession.on(
  [EVT_PLAY, EVT_PAUSE, EVT_RATE_CHANGE, EVT_ENDED],
  segmentsListeners.playSegments
);
videoSession.on([EVT_PLAY, EVT_PAUSE], segmentsListeners.keepAlive);

export default videoSession;
